import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { marked } from 'marked';

const MessageContent: React.FC<{ content: string; isUser: boolean }> = ({ content, isUser }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(content);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy text:', err);
    }
  };

  if (isUser) {
    return <p className="whitespace-pre-wrap">{content}</p>;
  }

  // Configure marked options
  marked.setOptions({
    breaks: true,
    gfm: true,
    headerIds: false,
    pedantic: false,
    mangle: false,
    headerPrefix: '',
  });

  return (
    <div className="relative group">
      <button
        onClick={handleCopy}
        className="absolute top-0 right-0 p-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-slate-400 hover:text-slate-200"
        title={copied ? "Copied!" : "Copy response"}
      >
        {copied ? (
          <Check className="w-4 h-4" />
        ) : (
          <Copy className="w-4 h-4" />
        )}
      </button>
      <div 
        className="message-content prose prose-invert max-w-none pr-8"
        dangerouslySetInnerHTML={{ 
          __html: marked.parse(content, {
            walkTokens: (token: any) => {
              if (token.type === 'list') {
                token.raw = token.raw.replace(/^\s*\d+\.\s/gm, '');
              }
            }
          })
        }} 
      />
    </div>
  );
};

export default MessageContent;